import { config } from "../config";
import { hasBranding } from "../utils";
import { useNavigateTo } from "./useRouteParams";
export var usePlansAndPricingRoute = function() {
    var navigateTo = useNavigateTo();
    var navigateToPlansAndPricing = function() {
        var _window_branding;
        if (hasBranding(window) && ((_window_branding = window.branding) === null || _window_branding === void 0 ? void 0 : _window_branding.vendorId) === "optus") {
            window.open(config.optusPricingPageUrl, "_blank", "noopener,noreferrer");
            return false;
        } else {
            navigateTo("/plans-and-pricing");
            return true;
        }
    };
    return navigateToPlansAndPricing;
};

//# sourceMappingURL=usePlansAndPricingRoute.js.map